/**
 * @generated SignedSource<<d96a497aaba0010fcdb69dffe63c53e8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Rate_userProfile$data = {
  readonly visitorCanEdit: boolean;
  readonly workPreferences: {
    readonly minimumHourlyRate: number | null;
  };
  readonly " $fragmentType": "Rate_userProfile";
};
export type Rate_userProfile$key = {
  readonly " $data"?: Rate_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"Rate_userProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Rate_userProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "WorkPreferences",
      "kind": "LinkedField",
      "name": "workPreferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minimumHourlyRate",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};

(node as any).hash = "193aa96b189b83f4e486076cfb881703";

export default node;
